import React, { useEffect, useRef } from 'react';
import { Paper, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Chart from 'chart.js/auto';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    height: '100%'
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600
  },
  chartContainer: {
    position: 'relative',
    height: 280
  }
}));

const FinanceSeriesChart = ({ title, labels = [], datasets = [], emptyLabel = 'No data available' }) => {
  const classes = useStyles();
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || labels.length === 0 || datasets.length === 0) return undefined;

    const ctx = canvasRef.current.getContext('2d');

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: datasets.map((dataset) => ({
          ...dataset,
          tension: 0.35,
          fill: false,
          pointRadius: 2,
          pointHoverRadius: 4,
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        plugins: {
          legend: {
            position: 'bottom',
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [datasets, labels]);

  if (labels.length === 0 || datasets.length === 0) {
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
        <Box display="flex" justifyContent="center" alignItems="center" height={280}>
          <Typography color="textSecondary">{emptyLabel}</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <Box className={classes.chartContainer}>
        <canvas ref={canvasRef} />
      </Box>
    </Paper>
  );
};

export default FinanceSeriesChart;
